import React from "react";
import { NeedsYouPanel } from "./NeedsYouPanel";
import { JobsPanel } from "./JobsPanel";
import { RetainerStatusBlock } from "./RetainerStatusBlock";

// Beast V1 Checkpoint 4 — Operations Home.
// GOOD MORNING → NEEDS YOU → JOBS. No KPI vanity cards, no charts.
// The purpose: "What requires me?" + "What work is happening?"
const greetingFor = (name) => {
  const hour = new Date().getHours();
  const salutation =
    hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";
  const firstName = (name || "").trim().split(/\s+/)[0] || "there";
  return `${salutation}, ${firstName}`;
};

export const OperationsHome = ({ user, onNavigate, focusJobId, onFocusHandled }) => {
  return (
    <div data-testid="operations-home" className="space-y-6">
      <div>
        <h1
          data-testid="operations-greeting"
          className="font-display text-3xl sm:text-4xl font-bold"
        >
          {greetingFor(user?.name)}
        </h1>
        <div className="text-sm text-[#A3A3A3] mt-1">
          Here's what needs your attention and what's in flight.
        </div>
      </div>

      <NeedsYouPanel onNavigate={onNavigate} />

      <RetainerStatusBlock onNavigate={onNavigate} />

      <JobsPanel
        compact
        focusJobId={focusJobId}
        onFocusHandled={onFocusHandled}
      />
    </div>
  );
};
